import React from 'react'

export function renderChecboxField(field)
{
   // const color = field.warning ? 'red':''
    return (
        <label className="checkbox-inline c-checkbox">
                <input  {...field.input}  type="checkbox" name={field.name} id={field.id ? field.id:''}  checked={field.checked} disabled={field.disabled ? field.disabled : false} />
                <em className="fa fa-check" />&nbsp;&nbsp;{field.label}
        </label> 
    )
}



// WEBPACK FOOTER //
// ./src/modules/components/checkboxfieldcomponent.js